import script from "./FamilyGroupSharedResearchGroups.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupSharedResearchGroups.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupSharedResearchGroups.vue?vue&type=style&index=0&id=5323a215&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5323a215"]])

export default __exports__